import { Component, Input, OnInit, inject } from "@angular/core";
import { Store } from "@ngrx/store";
import { MatDialog } from "@angular/material/dialog";
import { Router } from "@angular/router";
import { AvailabilityCodeStore } from "@app/services/store/availability-code-store";
import { BaseDataTablePageDirective } from "@app/view/shared/base-pages/base-data-table-page/base-data-table-page.directive";
import { SystemSearchMetaRestService } from "@app/services/hal/system-search-meta-rest.service";
import { UntypedFormBuilder } from "@angular/forms";
import { NgxUiLoaderService } from "ngx-ui-loader";
import { AvailabilityCode } from "@app/models/rest/availability-code";
import { ServiceErrorHandlerService } from "@app/view/shared/service-error-handler.service";
import { MatToolbar } from "@angular/material/toolbar";
import { MatButton } from "@angular/material/button";
import { GridComponent } from "../../../shared/base-pages/base-data-table-page/grid.component";
import { MatPaginator } from "@angular/material/paginator";
import { TranslatePipe } from "@ngx-translate/core";

@Component({
  selector: "app-availability-code-list",
  templateUrl: "./availability-code-list.component.html",
  styleUrls: ["./availability-code-list.component.scss"],
  imports: [MatToolbar, MatButton, GridComponent, MatPaginator, TranslatePipe]
})
export class AvailabilityCodeListComponent
  extends BaseDataTablePageDirective<AvailabilityCode>
  implements OnInit
{
  availabilityCodeStore: AvailabilityCodeStore;
  protected store: Store<any>;
  protected dialog: MatDialog;
  protected formBuilder: UntypedFormBuilder;
  protected router = inject(Router);
  serverErrorHandler: ServiceErrorHandlerService;
  protected ngxUiLoaderService: NgxUiLoaderService;

  @Input()
  public columns: object[] = [
    // {
    //   field: 'id',
    //   text: 'ID',
    //   flex: 1,
    //   editor: false
    // },
    {
      field: "availabilityType",
      text: "Type",
      flex: 1,
      editor: { type: "dropdown", items: ["ASSIGN", "BLOCK"] }
    },
    {
      field: "description",
      text: "Description",
      flex: 3,
      editor: true
    }
  ];

  constructor() {
    const systemSearchMetaRestService = inject(SystemSearchMetaRestService);
    const availabilityCodeStore = inject(AvailabilityCodeStore);
    const store = inject<Store<any>>(Store);
    const dialog = inject(MatDialog);
    const formBuilder = inject(UntypedFormBuilder);
    const serverErrorHandler = inject(ServiceErrorHandlerService);
    const ngxUiLoaderService = inject(NgxUiLoaderService);

    super(
      systemSearchMetaRestService,
      availabilityCodeStore,
      store,
      dialog,
      "AvailabilityCode",
      formBuilder,
      serverErrorHandler,
      ngxUiLoaderService
    );

    this.availabilityCodeStore = availabilityCodeStore;
    this.store = store;
    this.dialog = dialog;
    this.formBuilder = formBuilder;
    this.serverErrorHandler = serverErrorHandler;
    this.ngxUiLoaderService = ngxUiLoaderService;
  }

  public get pristine() {
    return (
      !this.gridStore.changes ||
      (this.gridStore.changes.added.length === 0 &&
        this.gridStore.changes.removed.length === 0 &&
        this.gridStore.changes.modified.length === 0)
    );
  }

  ngOnInit() {
    super.ngOnInit();
    this.gridStore.autoCommit = false;
    this.gridStore.load({});
  }

  addRow() {
    this.gridStore.add([
      {
        availabilityType: "ASSIGN",
        description: ""
      }
    ]);
  }
}
